import jwtDecode from 'jwt-decode'
import { isNumber, isObject } from 'lodash'

import { disableApiAuthorization, enableApiAuthorization } from '../../services/api'

const ADMIN_PANEL_TOKEN = 'admin_token'

// TODO: we should move this out of here.
export const LOGIN_PATH = '/login'
export const RESET_PASSWORD_PATH = '/account/reset-password'
export const CHANGE_PASSWORD_PATH = '/account/change-password'
export const NEW_PASSWORD_PATH = '/account/welcome'
export const DEFAULT_ROUTE = '/dashboard/'

type JwtPayload = {
  userId: number
}

export function getUserIdInToken(): number | null {
  const token = getToken()
  if (!token) {
    return null
  }
  try {
    const jwtPayload = jwtDecode<JwtPayload>(token)
    if (!isValidToken(jwtPayload)) {
      removeToken()
      return null
    }

    return jwtPayload.userId
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error((error as Error).stack)
    return null
  }
}

export function getToken() {
  return localStorage.getItem(ADMIN_PANEL_TOKEN)
}

export function storeToken(token: string) {
  localStorage.setItem(ADMIN_PANEL_TOKEN, token)
  enableApiAuthorization(token)
}

export function removeToken() {
  localStorage.removeItem(ADMIN_PANEL_TOKEN)
  disableApiAuthorization()
}

function isValidToken(tokenInformation: unknown): boolean {
  if (!isObject(tokenInformation)) {
    return false
  }

  // eslint-disable-next-line dot-notation
  return isNumber(tokenInformation['userId'])
}

// Enable authorization when initializing in case the tokens already exist.
enableApiAuthorization(getToken())
